import { useSearchParams, Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Seo from "@/components/Seo";
import { XCircle } from "lucide-react";

const LABELS = {
  lead_unlock: "Lead unlock", subscription_pro: "Contractor Pro plan",
  subscription_prem: "Contractor Premium plan", customer_deposit: "Booking deposit",
  featured_suburb: "Featured suburb",
};

export default function PayCancelled() {
  const [params] = useSearchParams();
  const purpose = params.get("purpose");
  return (
    <PublicLayout>
      <Seo title="Payment cancelled | Site Cleanup" />
      <section className="py-20 md:py-28">
        <div className="rs-container max-w-2xl text-center">
          <XCircle className="mx-auto text-asphalt" size={48} />
          <span className="rs-eyebrow mt-6 block">Payment cancelled</span>
          <h1 className="mt-3 font-display text-4xl uppercase">No charge was made.</h1>
          <p className="mt-4 text-muted-foreground">You've cancelled the {LABELS[purpose] || "payment"} checkout. Nothing has been billed. You can come back to it any time.</p>
          <div className="mt-8 flex justify-center gap-3 flex-wrap">
            <Link to="/pricing" className="rs-btn-primary">Back to pricing</Link>
            <Link to="/" className="rs-btn-outline">Home</Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
